import { useContext } from 'react'
import { motion } from 'framer-motion'
import Footer from '../landing/components/Footer'
import FeaturesAlternating from '../landing/components/FeaturesAlternating'
import { RouteTransitionContext } from '../components/AnimatedRoutes'

const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.38, 0.005, 0.215, 1] as const },
  },
}

const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12 } },
}

export default function FeaturesPage() {
  const isTransitioning = useContext(RouteTransitionContext)

  return (
    <div className="min-h-screen bg-oak-cream">
      <section className="pb-8 pt-28 md:pb-16 md:pt-36">
        <motion.div
          variants={stagger}
          initial="hidden"
          animate={isTransitioning ? 'hidden' : 'visible'}
          className="mx-auto max-w-nav px-6"
        >
          <motion.span
            variants={fadeUp}
            className="text-sm font-semibold uppercase tracking-widest text-gold-500"
          >
            Features
          </motion.span>
          <motion.h1
            variants={fadeUp}
            className="mt-4 font-serif text-[clamp(48px,8vw,120px)] leading-[0.85] tracking-[-2.88px] text-oak-black"
          >
            Everything you need
          </motion.h1>
          <motion.p
            variants={fadeUp}
            className="mt-6 max-w-[700px] text-[clamp(16px,2vw,22px)] font-medium leading-[1.3] tracking-[-0.2px] text-oak-black/70 md:mt-8"
          >
            Everything a social commerce platform should give your community — a marketplace, forums, payments, and messaging — so members can buy, sell, and trade together.
          </motion.p>
        </motion.div>
      </section>
      <FeaturesAlternating />
      <Footer />
    </div>
  )
}
